import { TileLayer, BitmapLayer, A5Layer } from "deck.gl";

import Colors from "./colors.json";

export class OSMLayer extends TileLayer {
  constructor() {
    super({
      id : 'osm-layer',

      data: [
        'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
      ],

      tileSize: 256,

      renderSubLayers: (props) => {
        const {
          bbox: { west, south, east, north }
        } = props.tile;

        return new BitmapLayer(props, {
          data: null,
          image: props.data,
          bounds: [west, south, east, north],
        });
      }
    });
  };
}

export function renderDataLayer(props) {
  const layers = props.data? props.data.map((d, i) =>
    new A5Layer({
      id: `data-layer-${i}`,
      data: d,
      visible: props.visible[i],
      getPentagon: d => d.a5,
      getFillColor: d => Colors[d.distance],
      getElevation: d => d.num_passengers,
      elevationScale: 0.025,
      pickable: true,
      filled: true,
      stroked: true,
      wireframe: true,
      extruded: true,
    })
  ) : [];

  return layers;
}

export function renderAllLayers(props) {
  const osmLayer = new OSMLayer();
  const dataLayers = renderDataLayer(props);

  return [
    osmLayer,
    dataLayers,
  ];
}
